import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnInit,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PermissionService } from '../../../../services/permission.service';
import { ToastrService } from 'ngx-toastr';
import { HttpService } from '../../../../services/common/http/common.http.service';
import Swal from 'sweetalert2';
import {
  DataSetPessoa,
  ICriarApontamentoForm,
  IGetApontamentoByFilterResponse,
  IGetPessoaByFilterResponse,
  IPayloadCreateApontamentoManual,
  IPayloadUpdateApontamentoManual,
} from './criar-apontamento-layout.model';
import { IGetPessoaResponsePagina } from '../../../recursos-humanos/listagem-pessoas-layout/listagem-pessoas-layout.model';

type formOptions = 'nomePessoa' | 'motivo';
type IOptions = {
  name: string;
  value: string | number;
};
@Component({
  selector: 'app-criar-apontamento-layout',
  templateUrl: './criar-apontamento-layout.component.html',
  styleUrls: ['./criar-apontamento-layout.component.scss'],
})
export class CriarApontamentoLayoutComponent implements OnInit, AfterViewInit {
  permission: number = 2;
  totalEtapas: number = 2;
  loader: boolean = false;
  isMode: boolean = true;
  idApontamentoHora: number = 0;
  form: ICriarApontamentoForm = {
    nomePessoa: 0,
    dataEntrada: '',
    dataSaidaAlmoco: '',
    dataRetornoAlmoco: '',
    dataSaida: '',
    dataEntradaHoraExtra: '',
    dataSaidaHoraExtra: '',
    nuMotivo: 3,
    descricaoMotivo: '',
  };

  constructor(
    private router: Router,
    private httpService: HttpService,
    private permissionService: PermissionService,
    private changeDetectorRef: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    private toast: ToastrService
  ) {}

  ngOnInit() {
    this.permission = this.permissionService.getPermission();
    this.getPessoas();
    this.activateRoute();
    this.changeDetectorRef.detectChanges();
  }

  ngAfterViewInit(): void {}

  setForm(params: ICriarApontamentoForm) {
    this.form = {
      ...this.form,
      ...params,
    };
  }

  motivoOptions = [
    {
      name: 'Falha no reconhecimento facial',
      value: 1,
    },
    {
      name: 'Esquecimento do apontamento de horas',
      value: 2,
    },
    {
      name: 'Outros',
      value: 3,
    },
  ];

  pessoaOptions: IOptions[] = [
    {
      name: '',
      value: 0,
    },
  ];

  changeSelect(item: any, form: formOptions) {
    if (form == 'nomePessoa') this.form.nomePessoa = item;
    if (form == 'motivo') this.form.nuMotivo = item;
  }

  registrarApontamento() {
    this.loader = true;
    const form = this.form;

    if (
      form.dataEntrada &&
      form.dataRetornoAlmoco &&
      form.dataSaida &&
      form.dataSaidaAlmoco &&
      form.nomePessoa &&
      form.nuMotivo &&
      form.descricaoMotivo
    ) {
      if (this.isMode) {
        const payload = this.createPayload();
        this.httpService
          .usePost('CreateApontamentoHoraManual', payload)
          .add(() => {
            this.loader = false;
          });
      } else {
        const payload: IPayloadUpdateApontamentoManual = this.createPayload();
        payload.IdApontamento = this.idApontamentoHora;
        this.httpService
          .usePut('UpdateApontamentoHoraManual', payload)
          .add(() => {
            this.loader = false;
          });
      }
    } else {
      this.loader = false;
      Swal.fire({
        title: 'Alerta!',
        text: 'Preencha todos os campos obrigatórios',
        icon: 'error',
        confirmButtonText: 'Ok',
        confirmButtonColor: 'green',
      });
    }
  }

  createPayload() {
    const body:
      | IPayloadCreateApontamentoManual
      | IPayloadUpdateApontamentoManual = {
      IdPessoa: Number(this.form.nomePessoa),
      DtEntrada: String(this.form.dataEntrada),
      DtRetornoAlmoco: String(this.form.dataRetornoAlmoco),
      DtSaida: String(this.form.dataSaida),
      DtSaidaAlmoco: String(this.form.dataSaidaAlmoco),
      DtEntradaHoraExtra: String(this.form.dataEntradaHoraExtra),
      DtSaidaHoraExtra: String(this.form.dataSaidaHoraExtra),
      NuTipoMotivoApontamento: 1,
      TxTipoMotivoApontamento: this.form.descricaoMotivo,
    };
    return body;
  }

  activateRoute() {
    this.activatedRoute.queryParams.subscribe((item) => {
      if (Number(item['IdPessoa']) > 0) {
        const nomePessoa = Number(item['IdPessoa']);
        this.form.nomePessoa = nomePessoa;
        const id = Number(item['IdApontamento']);
        this.getApontamentoHora(id);
        this.idApontamentoHora = id;
        this.isMode = false;
      }
    });
  }

  getApontamentoHora(id: number) {
    this.loader = true;
    const IdApontamento = id;
    this.httpService
      .useGet('ApontamentosByFilters', { IdApontamento })
      .subscribe({
        next: (response: IGetApontamentoByFilterResponse) => {
          const responseForm = response.DataSet[0];
          this.pessoaOptions = [
            {
              name: responseForm.TxNome,
              value: responseForm.IdPessoa,
            },
          ];
          this.setForm({
            dataEntrada: this.formatDateForInput(responseForm.DtEntrada),
            dataRetornoAlmoco: this.formatDateForInput(
              responseForm.DtRetornoAlmoco
            ),
            dataSaida: this.formatDateForInput(responseForm.DtSaida),
            dataSaidaAlmoco: this.formatDateForInput(
              responseForm.DtSaidaAlmoco
            ),
            dataEntradaHoraExtra: this.formatDateForInput(
              responseForm.DtEntradaExtra
            ),
            dataSaidaHoraExtra: this.formatDateForInput(
              responseForm.DtSaidaExtra
            ),
            descricaoMotivo: responseForm.TxMotivo,
            nomePessoa: responseForm.IdPessoa,
            nuMotivo: 1,
          });
          this.loader = false;
        },
        error: (error: any) => {
          Swal.fire({
            title: 'Alerta!',
            text: 'O apontamento de horas selecionado não foi encontrado.',
            icon: 'error',
            confirmButtonText: 'Ok',
            confirmButtonColor: 'green',
          });
          this.router.navigate(['encarregado/listagem-ajustes']);
          this.loader = false;
        },
        complete: () => {},
      });
  }

  formatDateForInput(dateString: string): string {
    const date = new Date(dateString);

    const localOffset = date.getTimezoneOffset() * 60000;
    const localDate = new Date(date.getTime() - localOffset);

    const dateYear = localDate.getFullYear();
    if (dateYear < 2000) {
      return '';
    }

    return localDate.toISOString().slice(0, 16);
  }

  getPessoas() {
    return this.httpService.useGet('PessoaByFilter').subscribe({
      next: (response: IGetPessoaResponsePagina) => {
        this.pessoaOptions = response.DataSet.map((x: any) => {
          return {
            name: x.TxNome,
            value: x.IdPessoa,
          };
        });
      },
      error: (_error: any) => {
        this.toast.error('Não foi possível buscar listagem. Tente novamente!');
      },
      complete: () => {},
    });
  }

  validacaoForm() {
    if (
      !this.form.dataEntrada ||
      !this.form.dataRetornoAlmoco ||
      !this.form.dataSaida ||
      !this.form.dataSaidaAlmoco ||
      !this.form.nomePessoa ||
      !this.form.nuMotivo ||
      !this.form.descricaoMotivo
    ) {
      return false;
    }
    return true;
  }
}
